import { render, staticRenderFns } from "./positionlist.vue?vue&type=template&id=32c2bb8d&scoped=true"
import script from "./positionlist.vue?vue&type=script&lang=js"
export * from "./positionlist.vue?vue&type=script&lang=js"
import style0 from "./positionlist.vue?vue&type=style&index=0&id=32c2bb8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c2bb8d",
  null
  
)

export default component.exports